const url = "/api/v1/";
import { getToken } from "./user-service";
import axios from "axios";
import {
  collection,
  getDocs,
  addDoc,
  query,
  where,
  orderBy,
  or,
  and,
  doc,
  updateDoc,
  deleteDoc,
  getDoc,
  setDoc,
  Timestamp,
  writeBatch,
  limit
} from "firebase/firestore";
import { firestore } from "_utils/firebase-app";

export const getBeaconSubmittedTimes = async (iata) => {

  const new_url = url + "beacons/times/" + iata;

  return new Promise(async (resolve, reject) => {
    try {

      const token = await getToken();

      const response = await fetch(new_url, {
        method: "GET",
        headers: { "Firebase-UID": token },
      });

      let json = await response.json();

      if (response.status >= 400 && response.status < 600) {
        throw ('Issue getting wait times')
      }

      resolve(json);

    } catch (e) {
      reject(new Error(e));
    }
  });
};

export const getWaitingTimesList = async (iata) => {

  const new_url = url + "beacons/statistics/" + iata + '?noStatistics=true';

  return new Promise(async (resolve, reject) => {
    try {

      const token = await getToken();

      const response = await fetch(new_url, {
        method: "GET",
        headers: { "Firebase-UID": token },
      });

      let json = await response.json();

      if (response.status >= 400 && response.status < 600) {

        if (json.errors[0].msg == "missing") {
          // beacons do not exsist
          throw "Beacons are not yet available in ";
        } else {
          throw "Issue retrieving beacon information. Please make sure you have an internet connection and try again later.";
        }

      }

      resolve(json);

    } catch (e) {
      reject(new Error(e));
    }
  });
};

export const getUserBeaconHistory = async (uuid) => {

  const new_url = url + "beacons/statistics/getUserWaitingTimes/" + uuid;

  console.log('getting user beacon history', new_url);

  return new Promise(async (resolve, reject) => {
    try {

      const token = await getToken();

      const response = await fetch(new_url, {
        method: "GET",
        headers: { "Firebase-UID": token },
      });

      let json = await response.json();

      if (response.status >= 400 && response.status < 600) {

        if (json.errors[0].msg == "missing") {
          // beacons do not exsist
          throw "Beacons are not yet available in ";
        } else {
          throw "Issue retrieving beacon information. Please make sure you have an internet connection and try again later.";
        }

      }

      console.log('response ', json)
      resolve(json);

    } catch (e) {
      reject(new Error(e));
    }
  });
};

export const getWaitingTimes = async (params) => {

  const new_url = url + "beacons/statistics/" + params.iata;

  return new Promise(async (resolve, reject) => {
    try {

      const token = await getToken();

      const response = await fetch(new_url, {
        method: "GET",
        headers: { "Firebase-UID": token },
      });

      let json = await response.json();
      if (response.status >= 400 && response.status < 600) {

        if (json.errors[0].msg == "missing") {
          // beacons do not exsist
          throw "Beacons are not yet available in ";
        } else {
          throw "Issue retrieving beacon information. Please make sure you have an internet connection and try again later.";
        }

      }

      resolve(json.beacons);

    } catch (e) {
      reject(new Error(e));
    }
  });
};

export const postMinor = async (params) => {

  const new_url = url + "beacons/airports/" + params.iata + "/minors";

  return new Promise(async (resolve, reject) => {
    try {
      const token = await getToken();
      const response = await fetch(new_url, {
        method: "POST",
        body: JSON.stringify({ 'minor': params.minor, 'major': params.major, 'name': params.minorName, 'description': params.minorDescription, 'beaconId': params.beaconId, 'uuid': params.uuid }),
        headers: {
          "Firebase-UID": token,
          accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      let json = await response.json();

      console.log('response ', json)

      if (response.status >= 400 && response.status < 600) {
        if (json.errors[0].msg == "missing") {
          console.log('beacon error', json)
          // beacons do not exsist
          throw "Beacons are not yet available in ";
        } else {
          console.log('beacon error', json)
          throw json;
        }
      }
      resolve(json);
    } catch (e) {
      if (e['errors'] && e['errors'][0] && e['errors'][0]['msg']) {
        console.log('errorrrrrr', e['errors'][0]['msg'])
        let error = e['errors'][0]['msg']
        reject(error)
      }
      reject(new Error(e));

    }
  });
};

export const deleteMinor = async (params) => {
  const new_url = url + "beacons/airports/" + params.iata + "/minors";
  return new Promise(async (resolve, reject) => {
    try {
      const token = await getToken();
      const response = await fetch(new_url, {
        method: "DELETE",
        body: JSON.stringify({ 'beaconId': params.beaconId }),
        headers: {
          "Firebase-UID": token,
          accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      let json = await response.json();
      if (response.status >= 400 && response.status < 600) {
        if (json.errors[0].msg == "missing") {
          // beacons do not exsist
          throw "Beacons are not yet available in ";
        } else {
          throw "Issue retrieving beacon information. Please make sure you have an internet connection and try again later.";
        }
      }
      resolve(json);
    } catch (e) {
      reject(new Error(e));
    }
  });
};

export const getUuidAndCoordinates = async (params) => {
  const new_url = url + "beacons/airports/" + params + "/uuid";
  return new Promise(async (resolve, reject) => {
    try {
      const token = await getToken();
      const response = await fetch(new_url, {
        method: "GET",
        headers: { "Firebase-UID": token },
      });

      let json = await response.json();

      if (response.status >= 400 && response.status < 600) {
        if (json.errors[0].msg == "missing") {
          // beacons do not exsist
          throw "Beacons are not yet available in ";
        } else {
          throw "Issue retrieving beacon information. Please make sure you have an internet connection and try again later.";
        }
      }
      resolve(json);
    } catch (e) {
      reject(new Error(e));
    }
  });

}

export const getBeaconList = async (params) => {
  const beaconRef = collection(
    firestore,
    "beaconDetails",
    params.iata,
    "beacons"
  );
  const querySnapshot = await getDocs(beaconRef);
  const data = querySnapshot.docs.map((doc) => {
    return doc.data();
  });
  return data;
}
